import { Preset } from "@primeuix/themes/types";

const CustomTheme: Preset = {
    
    semantic: {
        primary: {
            50: "{orange.50}",
            100: "{orange.100}",
            200: "{orange.200}",
            300: "{orange.300}",
            400: "{orange.400}",
            500: "{orange.500}",
            600: "{orange.600}",
            700: "{orange.700}",
            800: "{orange.800}",
            900: "{orange.900}",
            950: "{orange.950}",
        },
        colorScheme: {
            light: {
                surface: {
                    0: "#ffffff",
                    50: "{slate.50}",
                    100: "{slate.100}",
                    200: "{slate.200}",
                    300: "{slate.300}",
                    400: "{slate.400}",
                    500: "{slate.500}",
                    600: "{slate.600}",
                    700: "{slate.700}",
                    800: "{slate.800}",
                    900: "{slate.900}",
                    950: "{slate.950}",
                },
                primary: {
                    color: "{orange.500}",
                    contrastColor: "#ffffff",
                    hoverColor: "{orange.600}",
                    activeColor: "{orange.700}",
                },
                highlight: {
                    background: "{primary.50}",
                    focusBackground: "{primary.100}",
                    color: "{primary.700}",
                    focusColor: "{primary.800}",
                },
            },
            dark: {
                primary: {
                    color: "{primary.400}",
                    contrastColor: "{surface.900}",
                    hoverColor: "{primary.300}",
                    activeColor: "{primary.200}",
                },
                highlight: {
                    background:
                        "color-mix(in srgb, {primary.400}, transparent 84%)",
                    focusBackground:
                        "color-mix(in srgb, {primary.400}, transparent 76%)",
                    color: "rgba(255,255,255,.87)",
                    focusColor: "rgba(255,255,255,.87)",
                },
            },
        },
    },
    components: {
        breadcrumb: {
            root: {
                padding: "0",
            },
        },
        datatable: {
            root: {
                borderColor: "{surface.200}",
            },
            headerCell: {
                background: "{blue.700}",
                color: "{surface.0}",
                borderColor: "{surface.200}",
            },
        },
    },
};

export default CustomTheme;
